import React from "react";
import Showall from "../components/showall";


function Shows() {
    return (
      <div className="App">
        <Showall/>
        
      </div>
    );
  }
  
  export default Shows;